const existInList = (guest, guestList) => {
    return guestList.find(
        (x) => 
        x && typeof x.phone != "undefined" && x.phone && x.phone != ''  // phone not empty
        && x.phone == guest.phone // not same phone
        && x.id != guest.id // not same guest
    );
}

export {existInList}